module.exports = new __parcel__URL__("jurassic-park.e566137e.jpg").toString();